'use client';

import { useState } from 'react';
import { initTelemetry } from '../../services/telemetry';

/**
 * Initializes the Faro browser SDK once per page load. Rendered from the
 * root layout so it applies to every route, the same way the old New Relic
 * Browser agent `<Script>` tag did. `useState`'s lazy initializer runs
 * exactly once per mount, matching the singleton-construction pattern
 * already used for the Unleash client in `GameButler.tsx`. `initTelemetry`
 * itself is fire-and-forget (it dynamically imports the SDK), so there's
 * nothing to store from the call.
 */
export const TelemetryInit = () => {
  useState(() => {
    initTelemetry();
    return null;
  });
  return null;
};
